/**
 * @fileoverview added by tsickle
 * Generated from: ragnarok-core/index-output.ts
 * @suppress {checkTypes,const,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode}
 */
goog.module('index_output');
var module = module || { id: 'index-output.ts' };
goog.require('tslib');
const tsickle_gridapp_1 = goog.requireType("output.gridapp");
const tsickle_interfaces_2 = goog.requireType("output.interfaces");
const tsickle_rerrorcode_3 = goog.requireType("output.rerrorcode");
const tsickle_utils_4 = goog.requireType("output.util.utils");
const tsickle_devicecapabilities_5 = goog.requireType("output.util.devicecapabilities");
const tsickle_virtualgamepad_6 = goog.requireType("output.input.virtualgamepad");
const tsickle_settings_7 = goog.requireType("output.util.settings");
const tsickle_index_output_8 = goog.requireType("gridserver_core.index_output");
const tsickle_index_output_9 = goog.requireType("rtcutils_core.index_output");
const tsickle_nskutils_10 = goog.requireType("output.nskutils");
const tsickle_nskinterfaces_11 = goog.requireType("output.nskinterfaces");
((/** @type {?} */ (window)))["Ragnarok"] = ((/** @type {?} */ (window)))["Ragnarok"] || {};
/* Typings to be exposed to library user */
const gridapp_1 = goog.require('output.gridapp');
window["Ragnarok"]["GridApp"] = gridapp_1.GridApp;
const interfaces_1 = goog.require('output.interfaces');
window["Ragnarok"]["defaultInputConfigFlags"] = interfaces_1.defaultInputConfigFlags;
/** @typedef {!tsickle_interfaces_2.HotkeyKeyWithKeyName} */
exports.HotkeyKeyWithKeyName; // re-export typedef
/** @typedef {!tsickle_interfaces_2.HotkeyKeyWithCodeName} */
exports.HotkeyKeyWithCodeName; // re-export typedef
/** @typedef {!tsickle_interfaces_2.LocalHotkeyModifierAndKey} */
exports.LocalHotkeyModifierAndKey; // re-export typedef
/** @typedef {!tsickle_interfaces_2.RemoteHotkeyModifierAndKey} */
exports.RemoteHotkeyModifierAndKey; // re-export typedef
/** @typedef {!tsickle_interfaces_2.Hotkey} */
exports.Hotkey; // re-export typedef
/** @typedef {!tsickle_interfaces_2.InputConfigFlags} */
exports.InputConfigFlags; // re-export typedef
/** @typedef {!tsickle_interfaces_2.clientShutDownCallbackType} */
exports.clientShutDownCallbackType; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StreamingSettings} */
exports.StreamingSettings; // re-export typedef
/** @typedef {!tsickle_interfaces_2.Track} */
exports.Track; // re-export typedef
/** @typedef {!tsickle_interfaces_2.Stream} */
exports.Stream; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StartSessionResultEvent} */
exports.StartSessionResultEvent; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StopSessionResultEvent} */
exports.StopSessionResultEvent; // re-export typedef
/** @typedef {!tsickle_interfaces_2.GetSessionResult} */
exports.GetSessionResult; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StreamingTerminatedEvent} */
exports.StreamingTerminatedEvent; // re-export typedef
/** @typedef {!tsickle_interfaces_2.GamepadDataHandler} */
exports.GamepadDataHandler; // re-export typedef
/** @typedef {!tsickle_interfaces_2.VibrationHandler} */
exports.VibrationHandler; // re-export typedef
/** @typedef {!tsickle_interfaces_2.Zoneless} */
exports.Zoneless; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StreamingStateLegacy} */
exports.StreamingStateLegacy; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StreamingWarnings} */
exports.StreamingWarnings; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StreamingQuality} */
exports.StreamingQuality; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StreamUpdateEvent} */
exports.StreamUpdateEvent; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StreamingResolution} */
exports.StreamingResolution; // re-export typedef
/** @typedef {!tsickle_interfaces_2.StreamingEvent} */
exports.StreamingEvent; // re-export typedef
/** @typedef {!tsickle_interfaces_2.InitParams} */
exports.InitParams; // re-export typedef
/** @typedef {!tsickle_interfaces_2.MicStateEvent} */
exports.MicStateEvent; // re-export typedef
/** @typedef {!tsickle_interfaces_2.JsEventsCommonData} */
exports.JsEventsCommonData; // re-export typedef
/** @typedef {!tsickle_interfaces_2.JsEventsConfig} */
exports.JsEventsConfig; // re-export typedef
/** @typedef {!tsickle_interfaces_2.EventDataElements} */
exports.EventDataElements; // re-export typedef
const rerrorcode_1 = goog.require('output.rerrorcode');
const utils_1 = goog.require('output.util.utils');
window["Ragnarok"]["ChooseStreamingSettings"] = utils_1.ChooseStreamingSettings;
window["Ragnarok"]["ChooseStreamingResolution"] = utils_1.ChooseStreamingResolution;
window["Ragnarok"]["InitializeUtils"] = utils_1.InitializeUtils;
window["Ragnarok"]["GetSupportedAudioChannelCount"] = utils_1.GetSupportedAudioChannelCount;
/** @typedef {!tsickle_utils_4.EdgeInsets} */
exports.EdgeInsets; // re-export typedef
const devicecapabilities_1 = goog.require('output.util.devicecapabilities');
window["Ragnarok"]["GetDeviceCapabilities"] = devicecapabilities_1.GetDeviceCapabilities;
window["Ragnarok"]["getDeviceCapabilities"] = devicecapabilities_1.getDeviceCapabilities;
window["Ragnarok"]["serializeDeviceCapabilities"] = devicecapabilities_1.serializeDeviceCapabilities;
window["Ragnarok"]["getSupportedCodecs"] = devicecapabilities_1.getSupportedCodecs;
/** @typedef {!tsickle_devicecapabilities_5.VideoMode} */
exports.VideoMode; // re-export typedef
/** @typedef {!tsickle_devicecapabilities_5.ScaledVideoMode} */
exports.ScaledVideoMode; // re-export typedef
/** @typedef {!tsickle_devicecapabilities_5.DeviceCapabilities} */
exports.DeviceCapabilities; // re-export typedef
/** @typedef {!tsickle_devicecapabilities_5.StreamFeatures} */
exports.StreamFeatures; // re-export typedef
const virtualgamepad_1 = goog.require('output.input.virtualgamepad');
window["Ragnarok"]["VirtualGamepadHandler"] = virtualgamepad_1.VirtualGamepadHandler;
/** @typedef {!tsickle_virtualgamepad_6.VirtualGamepad} */
exports.VirtualGamepad; // re-export typedef
const settings_1 = goog.require('output.util.settings');
window["Ragnarok"]["ConfigureRagnarokSettings"] = settings_1.ConfigureRagnarokSettings;
window["Ragnarok"]["RagnarokSettings"] = settings_1.RagnarokSettings;
/** @typedef {!tsickle_settings_7.RemoteConfigData} */
exports.RemoteConfigData; // re-export typedef
/** @typedef {!tsickle_settings_7.RagnarokConfigData} */
exports.RagnarokConfigData; // re-export typedef
const index_output_1 = goog.require('gridserver_core.index_output');
window["Ragnarok"]["GridServer"] = index_output_1.GridServer;
window["Ragnarok"]["PassThruServer"] = index_output_1.PassThruServer;
window["Ragnarok"]["GridServerSettings"] = index_output_1.GridServerSettings;
window["Ragnarok"]["ConfigureGridServerSettings"] = index_output_1.ConfigureGridServerSettings;
window["Ragnarok"]["configureSessionControlSettings"] = index_output_1.configureSessionControlSettings;
window["Ragnarok"]["CLIENT_VERSION"] = index_output_1.CLIENT_VERSION;
window["Ragnarok"]["CLIENT_IDENTIFICATION"] = index_output_1.CLIENT_IDENTIFICATION;
window["Ragnarok"]["createSessionControl"] = index_output_1.createSessionControl;
window["Ragnarok"]["updateSessionParameters"] = index_output_1.updateSessionParameters;
window["Ragnarok"]["isCancelCode"] = index_output_1.isCancelCode;
window["Ragnarok"]["isResumableSessionState"] = index_output_1.isResumableSessionState;
window["Ragnarok"]["getResumableSession"] = index_output_1.getResumableSession;
window["Ragnarok"]["SessionControlTelemetry"] = index_output_1.SessionControlTelemetry;
/** @typedef {!tsickle_index_output_8.GridServerConfigData} */
exports.GridServerConfigData; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionControlConfigData} */
exports.SessionControlConfigData; // re-export typedef
/** @typedef {!tsickle_index_output_8.ConnectionInfo} */
exports.ConnectionInfo; // re-export typedef
/** @typedef {!tsickle_index_output_8.AdUpdate} */
exports.AdUpdate; // re-export typedef
/** @typedef {!tsickle_index_output_8.AdData} */
exports.AdData; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionAdMediaFileData} */
exports.SessionAdMediaFileData; // re-export typedef
/** @typedef {!tsickle_index_output_8.MonitorSettings} */
exports.MonitorSettings; // re-export typedef
/** @typedef {!tsickle_index_output_8.StreamingFeatures} */
exports.StreamingFeatures; // re-export typedef
/** @typedef {!tsickle_index_output_8.GsInitParams} */
exports.GsInitParams; // re-export typedef
/** @typedef {!tsickle_index_output_8.MetaData} */
exports.MetaData; // re-export typedef
/** @typedef {!tsickle_index_output_8.ActiveSessionInfo} */
exports.ActiveSessionInfo; // re-export typedef
/** @typedef {!tsickle_index_output_8.StreamParam} */
exports.StreamParam; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionParams} */
exports.SessionParams; // re-export typedef
/** @typedef {!tsickle_index_output_8.ActiveSessionResultEvent} */
exports.ActiveSessionResultEvent; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionProgressUpdateEvent} */
exports.SessionProgressUpdateEvent; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionUpdate} */
exports.SessionUpdate; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionUpdateEvent} */
exports.SessionUpdateEvent; // re-export typedef
/** @typedef {!tsickle_index_output_8.ServerInfo} */
exports.ServerInfo; // re-export typedef
/** @typedef {!tsickle_index_output_8.StreamInfo} */
exports.StreamInfo; // re-export typedef
/** @typedef {!tsickle_index_output_8.GridSession} */
exports.GridSession; // re-export typedef
/** @typedef {!tsickle_index_output_8.ServerError} */
exports.ServerError; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionUpdateCallback} */
exports.SessionUpdateCallback; // re-export typedef
/** @typedef {!tsickle_index_output_8.Session} */
exports.Session; // re-export typedef
/** @typedef {!tsickle_index_output_8.InitializeParameters} */
exports.InitializeParameters; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionParameters} */
exports.SessionParameters; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionStartResumeResult} */
exports.SessionStartResumeResult; // re-export typedef
/** @typedef {!tsickle_index_output_8.ActiveSessionsResult} */
exports.ActiveSessionsResult; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionInfoResult} */
exports.SessionInfoResult; // re-export typedef
/** @typedef {!tsickle_index_output_8.SessionControl} */
exports.SessionControl; // re-export typedef
const index_output_2 = goog.require('rtcutils_core.index_output');
window["Ragnarok"]["CHANGELIST"] = index_output_2.CHANGELIST;
window["Ragnarok"]["getPlatformDetails"] = index_output_2.getPlatformDetails;
// Dev client is still relying on these interfaces, so export them intentionally
window["Ragnarok"]["performHttpRequest"] = index_output_2.performHttpRequest;
window["Ragnarok"]["AddPlatformTelemetry"] = index_output_2.AddPlatformTelemetry;
window["Ragnarok"]["LogImpl"] = index_output_2.LogImpl;
window["Ragnarok"]["translatePlatformDetailsForPayload"] = index_output_2.translatePlatformDetailsForPayload;
window["Ragnarok"]["translatePlatformDetailsForClientHeader"] = index_output_2.translatePlatformDetailsForClientHeader;
window["Ragnarok"]["registerLogCallback"] = index_output_2.registerLogCallback;
/** @typedef {!tsickle_index_output_9.PlatformDetails} */
exports.PlatformDetails; // re-export typedef
/** @typedef {!tsickle_index_output_9.LogData} */
exports.LogData; // re-export typedef
/** @typedef {!tsickle_index_output_9.LogEvent} */
exports.LogEvent; // re-export typedef
/** @typedef {!tsickle_index_output_9.authTokenCallbackType} */
exports.authTokenCallbackType; // re-export typedef
/** @typedef {!tsickle_index_output_9.AuthInfo} */
exports.AuthInfo; // re-export typedef
/** @typedef {!tsickle_index_output_9.RequestHttpOptions} */
exports.RequestHttpOptions; // re-export typedef
/** @typedef {!tsickle_index_output_9.Response} */
exports.Response; // re-export typedef
/** @typedef {!tsickle_index_output_9.PayloadPlatformDetails} */
exports.PayloadPlatformDetails; // re-export typedef
/** @typedef {!tsickle_index_output_9.ClientHeaderPlatformDetails} */
exports.ClientHeaderPlatformDetails; // re-export typedef
/** @typedef {!tsickle_index_output_9.TelemetryEventPayload} */
exports.TelemetryEventPayload; // re-export typedef
/** @typedef {!tsickle_index_output_9.Telemetry} */
exports.Telemetry; // re-export typedef
/** @typedef {!tsickle_index_output_9.TelemetryConfiguration} */
exports.TelemetryConfiguration; // re-export typedef
/** @typedef {!tsickle_index_output_9.TelemetryCommonData} */
exports.TelemetryCommonData; // re-export typedef
const nskutils_1 = goog.require('output.nskutils');
window["Ragnarok"]["getStreamerType"] = nskutils_1.getStreamerType;
window["Ragnarok"]["isFeatureSupported"] = nskutils_1.isFeatureSupported;
window["Ragnarok"]["IsFeatureSupported"] = nskutils_1.IsFeatureSupported;
window["Ragnarok"]["shouldDefaultEnableMic"] = nskutils_1.shouldDefaultEnableMic;
window["Ragnarok"]["getRecommendedBitrate"] = nskutils_1.getRecommendedBitrate;
window["Ragnarok"]["getStreamStartParameters"] = nskutils_1.getStreamStartParameters;
window["Ragnarok"]["estimateDataUsage"] = nskutils_1.estimateDataUsage;
window["Ragnarok"]["CalculateMaxBitrateKbps"] = nskutils_1.CalculateMaxBitrateKbps;
window["Ragnarok"]["CalculateDataUsage"] = nskutils_1.CalculateDataUsage;
window["Ragnarok"]["NskTelemetry"] = nskutils_1.NskTelemetry;
const nskinterfaces_1 = goog.require('output.nskinterfaces');
window["Ragnarok"]["createNskStreamClient"] = nskinterfaces_1.createNskStreamClient;
/** @typedef {!tsickle_nskinterfaces_11.VideoStreamSettings} */
exports.VideoStreamSettings; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.DownstreamVideoSettings} */
exports.DownstreamVideoSettings; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.UpstreamMediaSettings} */
exports.UpstreamMediaSettings; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.UpstreamVideoSettings} */
exports.UpstreamVideoSettings; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StreamStartData} */
exports.StreamStartData; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StreamStopData} */
exports.StreamStopData; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.CustomMessage} */
exports.CustomMessage; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.Resolution} */
exports.Resolution; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StreamStatistics} */
exports.StreamStatistics; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StreamQuality} */
exports.StreamQuality; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StreamWarning} */
exports.StreamWarning; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.TextCompositionEvent} */
exports.TextCompositionEvent; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.NskStreamClientDelegate} */
exports.NskStreamClientDelegate; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.VirtualInputController} */
exports.VirtualInputController; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StreamClientInitParameters} */
exports.StreamClientInitParameters; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StreamConnectionInfo} */
exports.StreamConnectionInfo; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StatTelemetryInfo} */
exports.StatTelemetryInfo; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.StreamStartParameters} */
exports.StreamStartParameters; // re-export typedef
/** @typedef {!tsickle_nskinterfaces_11.NskStreamClient} */
exports.NskStreamClient; // re-export typedef
